import { render, staticRenderFns } from "./RelatedPages.vue?vue&type=template&id=66760624&"
import script from "./RelatedPages.vue?vue&type=script&lang=ts&"
export * from "./RelatedPages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports